import { Injectable, inject } from "@angular/core";

import { urlConcat } from "@logex/framework/utilities";
import { LgConsole } from "@logex/framework/core";
import {
    VersionService,
    LG_APP_CONFIGURATION,
    LG_APP_SESSION,
    IVersion
} from "@logex/framework/lg-application";
import { AppSession } from "../app-session";

import { AppVersionSettings } from "@shared/scenario";
import { forkJoin, lastValueFrom } from "rxjs";
// ----------------------------------------------------------------------------------
//
export interface IScenario {
    id: number;
    clientId: number;
}

export interface IVersionExt extends IVersion {
    jaar: number;
    periode: number;
}

@Injectable({ providedIn: "root" })
export class ScenarioService<
    TScenario extends IScenario = IScenario
> extends VersionService<IVersionExt> {
    private _applicationConfiguration = inject(LG_APP_CONFIGURATION);
    private _lgConsole = inject(LgConsole);
    private _session = inject<AppSession>(LG_APP_SESSION);
    // ----------------------------------------------------------------------------------

    scenario: TScenario;

    // ----------------------------------------------------------------------------------

    async load(clientId: number, scenarioId: number): Promise<TScenario> {
        try {
            const params = {} as any;
            if (clientId != null) params.clientId = clientId;
            if (scenarioId != null) params.scenarioId = scenarioId;

            this.scenario = await lastValueFrom(
                this.http.get<TScenario>(
                    urlConcat(this._applicationConfiguration.applicationRoot, "boot/scenario"),
                    { params }
                )
            );

            return this.scenario;
        } catch (err) {
            this._lgConsole.error(
                `Error getting scenario ${scenarioId} for client ${clientId}`,
                err
            );
            return null;
        }
    }

    // ----------------------------------------------------------------------------------
    // Compatibility with VersionService<IVersion>
    // Needed to make scenario dialog working w/o big changes to the dialog itself.
    // It is a temporary solution

    reload(): void {
        this._version.next({
            ziekenhuiscode: this._session.clientId,
            id: this._session.scenarioId,
            display_version_id: this._session.scenarioId,
            is_primary: this._session.scenario?.isDefault,
            locked: this._session.scenario?.isLocked,
            jaar: this._session.scenario?.year,
            periode: this._session.scenario?.quarter,
            scenario_naam: this._session.scenario?.description,
            is_readonly: null,
            data_version_naam: null,
            date_created: `${this._session.scenario?.startDate.getMonth()}- ${this._session.scenario?.startDate.getFullYear()}`,
            periodName: null,
            is_test: false,
            scenario_omschrijving: null
        });
    }

    set(version: IVersionExt & { settings: AppVersionSettings }): void {
        this._version.next(version);
    }
}
